import { BrowserRouter, Route, Routes, useParams, Navigate } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import { HomePage } from "./pages/HomePage";
import { RelaySetPage } from "./pages/RelaySetPage";
import { NotePage } from "./pages/NotePage";
import { ProfilePage, MePage } from "./pages/ProfilePage";
import { RelaysPage, RelayPage } from "./pages/RelaysPage";
import { SearchPage } from "./pages/SearchPage";
import { NotificationsPage } from "./pages/NotificationsPage";
import { BookmarksPage } from "./pages/BookmarksPage";
import { ComposePage } from "./pages/ComposePage";
import { SettingsPage } from "./pages/SettingsPage";
import { ArticlesPage, ArticlePage, FollowingPage } from "./pages/ArticlesPage";
import NotFound from "./pages/NotFound";
import { nip19 } from "nostr-tools";

function Nip19Router() {
  const { nip19: identifier } = useParams<{ nip19: string }>();
  if (!identifier) return <NotFound />;
  let type: string | undefined;
  try {
    type = nip19.decode(identifier).type;
  } catch {
    // maybe raw hex relay path or unknown
    return <NotFound />;
  }
  if (type === 'npub' || type === 'nprofile') return <ProfilePage identifier={identifier} />;
  if (type === 'note' || type === 'nevent') return <NotePage identifier={identifier} />;
  if (type === 'naddr') return <ArticlePage naddr={identifier} />;
  return <NotFound />;
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/following" element={<FollowingPage />} />
        <Route path="/articles" element={<ArticlesPage />} />
        <Route path="/article/:naddr" element={<ArticleRoute />} />
        <Route path="/feed/:id" element={<RelaySetPage />} />
        <Route path="/relays" element={<RelaysPage />} />
        <Route path="/relay/:url" element={<RelayPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/bookmarks" element={<BookmarksPage />} />
        <Route path="/compose" element={<ComposePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/me" element={<MePage />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<Nip19Router />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

function ArticleRoute() {
  const { naddr } = useParams<{ naddr: string }>();
  if (!naddr) return <NotFound />;
  return <ArticlePage naddr={naddr} />;
}

export default AppRouter;
